import React, { useEffect } from 'react'

import { Loader, Title } from '@components/atoms'
import { ListHistory } from '@components/molecules'
import { dashboardAPI } from '@services/DashboardAPI'

import { Activitytyles } from './style'

const { container, titleIndex } = Activitytyles

export const ActivityHistory = () => {
	const [getActivityHistory, { isLoading, data }] =
		dashboardAPI.useGetActivityHistoryMutation()

	useEffect(() => {
		getActivityHistory()
	}, [getActivityHistory])

	return (
		<div className={container()}>
			<div className={titleIndex()}>
				<Title variant='h1' color='$neutral160'>
					Histórico de atividade
				</Title>
			</div>

			{isLoading ? (
				<>
					<Loader />
				</>
			) : (
				<ListHistory list={data || []} />
			)}
		</div>
	)
}
